import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import type { InputChangeEvent } from "@tql/ui-components-react/kendo/inputs";
import { Button } from "@tql/ui-components-react/tql/buttons";
import { Input } from "@tql/ui-components-react/tql/inputs/beta";
import { send_01 } from "@tql/ui-components-react/untitled/icons";
import { useCallback, useState } from "react";
import { useSearchParams } from "react-router";

import { TraxPageHeader } from "~/shared/components/trax-page-header/trax-page-header.tsx";
import { useIsMobile } from "~/shared/hooks/use-is-mobile.ts";
import { getBaseUrl } from "~/shared/utils/get-base-url.ts";

import { ShipmentResults } from "./shipment-results.tsx";
import * as styles from "./track-shipment.module.css";

const baseUrl = getBaseUrl();

export function TrackShipment() {
	const [searchParams, setSearchParams] = useSearchParams();
	const urlPoNumber = searchParams.get("searchNumber");
	const [poNumber, setPoNumber] = useState(urlPoNumber ?? "");

	const [searchPoNumber, setSearchPoNumber] = useState<number | null>(() => {
		if (!urlPoNumber) return null;
		const parsed = Number(urlPoNumber);
		return Number.isNaN(parsed) ? null : parsed;
	});

	const MOBILE_BREAKPOINT = 950;
	const isMobile = useIsMobile(MOBILE_BREAKPOINT);

	function handlePoNumberChange(event: InputChangeEvent) {
		setPoNumber(event.value);
	}

	function handleKeyDown(event: React.KeyboardEvent) {
		if (event.key === "Enter") {
			handleSearch();
		}
	}

	const handleSearch = useCallback(() => {
		const parsed = Number(poNumber);
		if (poNumber && !Number.isNaN(parsed)) {
			setSearchPoNumber(parsed);
			setSearchParams({ searchNumber: poNumber }, { replace: true });
		}
	}, [poNumber, setSearchParams]);

	return (
		<div className={styles.container}>
			<div className={styles.pageContent}>
				<div className={styles.headerRow}>
					{isMobile ? null : (
						<div>
							<TraxPageHeader title={"Shipment Tracking"} />
						</div>
					)}
					<div className={styles.logoWrapper}>
						<img
							alt={"TQL TRAX Logo"}
							className={styles.logo}
							src={`${baseUrl}/images/tql-trax-logo-black.png`}
						/>
					</div>
				</div>
				<div className={styles.searchSection}>
					<label className={styles.searchLabel} htmlFor={"po-number-input"}>
						Enter your TQL PO# or TQL LTL BOL#
					</label>
					<div className={styles.searchRow}>
						<Input
							id={"po-number-input"}
							name={"po-number-input"}
							onChange={handlePoNumberChange}
							onKeyDown={handleKeyDown}
							value={poNumber}
						/>
						<Button onClick={handleSearch} variant={"primary"}>
							<SvgIcon icon={send_01} size={"large"} /> Track Shipment
						</Button>
					</div>
				</div>
				{searchPoNumber === null ? null : (
					<div className={styles.contentArea}>
						<ShipmentResults poNumber={searchPoNumber} />
					</div>
				)}
			</div>
		</div>
	);
}
